import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Ad } from '@dmm/react-common-components';
import './styles.css';

import { listingPropTypes } from '../../../../../utils/commonPropTypes';
import ListingResult from '../ListingResult';
import LeaderBoardMid from '../../../../../components/Ads/LeaderBoardMid';
import MobileLinerAd from '../../../../../components/Ads/MobileLiner';
import { setPosition } from '../../../../../utils/paginationHelper';

class EnginesList extends React.PureComponent {
  render() {
    const AD_POSITION_OFFSET = 2;
    const AD_POSITION = 5;
    const MAX_DESKTOP_ADS = 2;
    let itemCount = 0;
    let desktopAdCount = 0;
    let mobileAdCount = 0;
    const {showAds, url, pos, tracking, labels, adParams } = this.props;
    return (
      <ol className={classnames('engines-list')}>
        {
          this.props.listings.map((listing, i) => {
            itemCount += 1;
            const position = setPosition(pos, i + 1);
            const listingArr = [
              <ListingResult
                key={listing.id}
                listing={listing}
                position={position}
                url={url}
                tracking={tracking}
                labels={labels}
              />
            ];

            if (showAds && itemCount === AD_POSITION_OFFSET) {
              listingArr.push(<li key={`deskAd${listing.id}`}><Ad {...adParams.leaderBoardAlphaParams} /></li>);
            } else
            if (showAds && (itemCount - AD_POSITION_OFFSET) % AD_POSITION === 0 && desktopAdCount < MAX_DESKTOP_ADS) {
              listingArr.push(<LeaderBoardMid key={`deskAd${listing.id}`} adNum={++desktopAdCount}/>);
            }
            if (showAds && itemCount % AD_POSITION === 0 && mobileAdCount < MAX_DESKTOP_ADS) {
              listingArr.push(<MobileLinerAd key={`mobAd${listing.id}`} adNum={++mobileAdCount}/>);
            }

            return listingArr;
          }).reduce((prev, next) => [prev, ...next], [])
        }
      </ol>
    );
  }
}

EnginesList.defaultProps = {
  showAds: false
};

EnginesList.propTypes = {
  adParams: PropTypes.object,
  labels: PropTypes.object.isRequired,
  listings: PropTypes.arrayOf(listingPropTypes).isRequired,
  pos: PropTypes.shape({
    page: PropTypes.string,
    pageSize: PropTypes.string,
  }).isRequired,
  tracking: PropTypes.object,
  url: PropTypes.string,
  showAds: PropTypes.bool
};

export default EnginesList;
